import { Pause, Play } from "lucide-react";
import React, { useState, useRef } from "react";

const SideBar = () => {
  const [playingAudioId, setPlayingAudioId] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRefs = useRef({});

  const handleAudioPlayPause = (audioId, previewUrl) => {
    if (playingAudioId !== null && playingAudioId !== audioId && audioRefs.current[playingAudioId]) {
      audioRefs.current[playingAudioId].pause();
      audioRefs.current[playingAudioId].currentTime = 0; 
    }

    const currentAudio = audioRefs.current[audioId];

   
    if (playingAudioId === audioId && isPlaying) {
      currentAudio.pause();
      setIsPlaying(false);
      setPlayingAudioId(null);
    } else {
      if (currentAudio) {
        currentAudio.src = previewUrl; 
        currentAudio.play();
        setPlayingAudioId(audioId);
        setIsPlaying(true);
      }
    }
  };

  return (
    <div className="w-64 bg-gray-800 text-white p-4">
      <h2 className="text-3xl font-semibold mb-6">Demo Audio</h2>
      <ul className="space-y-4">
  
        <li onClick={() => handleAudioPlayPause(1, "voices/0b845163ce614d588fa2ed7915ae23e4.mp3")} className="flex justify-between cursor-pointer items-center">
          Audio 1
          <button
            
            className="p-2 rounded-full bg-black/20 hover:bg-black/40 backdrop-blur-sm transition-colors"
          >
            {playingAudioId === 1 && isPlaying ? (
              <Pause className="w-5 h-5" />
            ) : (
              <Play className="w-5 h-5" />
            )}
          </button>
        
          <audio
            ref={(el) => (audioRefs.current[1] = el)}
            preload="auto"
          />
        </li>

        <li  onClick={() => handleAudioPlayPause(2, "voices/4b34a9ec2a7f407cac8750f196d0bc59.mp3")} className="flex justify-between cursor-pointer items-center">
          Audio 2
          <button
           
            className="p-2 rounded-full bg-black/20 hover:bg-black/40 backdrop-blur-sm transition-colors"
          >
            {playingAudioId === 2 && isPlaying ? (
              <Pause className="w-5 h-5" />
            ) : (
              <Play className="w-5 h-5" />
            )}
          </button>
          <audio
            ref={(el) => (audioRefs.current[2] = el)}
            preload="auto"
          />
        </li>
      </ul>
    </div>
  );
};

export default SideBar;
